import { apiSlice } from "../apiSlice";

export interface Payout {
  requesterType: string;
  amount: number;
  status: string;
  createdAt: {
    _seconds: number;
    _nanoseconds: number;
  };
  id: string;
  restaurant?: {
    displayName: string;
    restaurantIds: string[];
    userId: string;
  };
  cart?: {
    displayName: string;
    userId: string;
  };
}

export interface GetPayoutsResponse {
  restaurant: Payout[];
  cart: Payout[];
}

const API_BASE_DOMAIN = process.env.REACT_APP_API_BASE_DOMAIN_PRODUCTION;

export const payoutService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPayoutList: builder.query<GetPayoutsResponse, string>({
      query: (status) => ({
        url: `https://superadminhttps-getpayoutlist-${API_BASE_DOMAIN}-uc.a.run.app?status=${status}`,
        method: "GET",
      }),
    }),

    settlePayoutRequest: builder.mutation<
      void,
      { payoutRequestId: string; status: "Completed" | "Cancelled" }
    >({
      query: ({ payoutRequestId, status }) => ({
        url: `https://superadminhttps-settlepayoutrequest-${API_BASE_DOMAIN}-uc.a.run.app`,
        method: "POST",
        body: { payoutRequestId, status },
      }),
    }),
  }),
});

export const { useLazyGetPayoutListQuery, useSettlePayoutRequestMutation } = payoutService;
